import { render, staticRenderFns } from "./CopyRoleDialog.vue?vue&type=template&id=649d9e38&scoped=true"
import script from "./CopyRoleDialog.vue?vue&type=script&lang=ts"
export * from "./CopyRoleDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyRoleDialog.vue?vue&type=style&index=0&id=649d9e38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d9e38",
  null
  
)

export default component.exports